import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MapPinIcon, MailIcon, PhoneIcon, ArrowRightIcon, CheckIcon } from 'lucide-react';
import { Logo } from '../ui/Logo';
import { DISCLAIMER } from '../../data/content';
import { COMPANY } from '../../data/company';
import { useLanguage } from '../../i18n/LanguageContext';
export function Footer() {
  const {
    lang,
    t
  } = useLanguage();
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const quickLinks = [{
    label: t.nav.home,
    to: '/'
  }, {
    label: t.nav.about,
    to: '/about'
  }, {
    label: t.nav.services,
    to: '/services'
  }, {
    label: t.nav.howItWorks,
    to: '/how-it-works'
  }, {
    label: t.nav.faq,
    to: '/faq'
  }, {
    label: t.nav.contact,
    to: '/contact'
  }];
  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setSubscribed(true);
    setEmail('');
  };
  return <footer className="w-full bg-navy-950 text-navy-100" data-id="element-214" data-mp="394b4k1qy3e17">
      <div className="mx-auto max-w-container px-6 pt-20 pb-10" data-id="element-215" data-mp="2kcl337wsojvn">
        <div className="grid gap-14 lg:grid-cols-12" data-id="element-216" data-mp="2kba1neqtno7p">
          <div className="lg:col-span-4" data-id="element-217" data-mp="2p4uz95oi6g6d">
            <Logo variant="light" data-id="element-218" data-mp="2p5o1btciohi6" />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-navy-100/70" data-id="element-219" data-mp="2bcyb1cpygqf9">
              {t.footer.about}
            </p>
            <ul className="mt-8 space-y-3 text-sm text-navy-100/70" data-id="element-220" data-mp="2gc17w9vs7qc5">
              <li className="flex gap-3" data-id="element-221" data-mp="340u7cgbm4gbi">
                <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-222" data-mp="341vhmikt0ys6" />
                <span data-id="element-223" data-mp="381w9p60tt8hp">{t.footer.address}</span>
              </li>
              <li className="flex gap-3" data-id="element-224" data-mp="2u3pho6ik62py">
                <PhoneIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-225" data-mp="2u50mm9nqpgin" />
                <a href={`tel:${COMPANY.phoneHref}`} className="transition-colors hover:text-gold" data-id="element-226" data-mp="2z068j8h56v6q">
                  {COMPANY.phone}
                </a>
              </li>
              <li className="flex gap-3" data-id="element-227" data-mp="1nnvp3soagbey">
                <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-228" data-mp="1nkhk0co8po3t" />
                <a href={`mailto:${COMPANY.email}`} className="transition-colors hover:text-gold" data-id="element-229" data-mp="13mtz5zjxmt0g">
                  {COMPANY.email}
                </a>
              </li>
            </ul>
          </div>

          <nav className="lg:col-span-2" aria-label={t.footer.quickLinks} data-id="element-230" data-mp="uq2xn7mm2lyh">
            <h2 className="eyebrow text-gold" data-id="element-231" data-mp="pst8lt34wcb6">{t.footer.quickLinks}</h2>
            <ul className="mt-6 space-y-3 text-sm" data-id="element-232" data-mp="kvazo2p49x36">
              {quickLinks.map(l => <li key={l.to} data-id="element-233" data-mp="fuvmbb4u4pl7">
                  <Link to={l.to} className="text-navy-100/70 transition-colors hover:text-gold" data-id="element-234" data-mp="ftu0cbma6iop">
                    {l.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <nav className="lg:col-span-2" aria-label={t.footer.legal} data-id="element-235" data-mp="6wtfug2c14qj">
            <h2 className="eyebrow text-gold" data-id="element-236" data-mp="2672pk251qyrz">{t.footer.legal}</h2>
            <ul className="mt-6 space-y-3 text-sm" data-id="element-237" data-mp="21886r072xa7v">
              {t.footer.legalLinks.map(l => <li key={l} data-id="element-238" data-mp="28ssjwt916go1">
                  <a href="#" className="text-navy-100/70 transition-colors hover:text-gold" data-id="element-239" data-mp="28rhfcr7rh4vv">
                    {l}
                  </a>
                </li>)}
            </ul>
          </nav>

          <div className="lg:col-span-4" data-id="element-240" data-mp="2iiltjopm4lpn">
            <h2 className="eyebrow text-gold" data-id="element-241" data-mp="2nheygsqu34e7">{t.footer.newsletterTitle}</h2>
            <p className="mt-6 text-sm text-navy-100/70" data-id="element-242" data-mp="2niq4z0bnyq90">{t.footer.newsletterText}</p>
            <form onSubmit={handleSubscribe} className="mt-5" data-id="element-243" data-mp="1pv9ahoinuw13">
              <label htmlFor="newsletter-email" className="sr-only" data-id="element-244" data-mp="1ut0za9o0e212">
                {t.footer.emailLabel}
              </label>
              <div className="flex overflow-hidden rounded-full border border-white/15 bg-white/5 focus-within:border-gold/60" data-id="element-245" data-mp="1ztf99x967m1q">
                <input id="newsletter-email" type="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder={t.footer.emailPlaceholder} className="w-full bg-transparent px-5 py-3 text-sm text-white placeholder:text-navy-100/40 focus:outline-none" data-id="element-246" data-mp="3b6rhekbyqqtp" />
                <button type="submit" aria-label={t.footer.subscribe} className="flex items-center gap-2 bg-gold px-5 text-[12px] font-semibold uppercase tracking-[0.14em] text-navy transition-colors hover:bg-gold-light" data-id="element-247" data-mp="3npdcuw3inska">
                  <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-248" data-mp="3rr8ek1pd07yl" />
                </button>
              </div>
              {subscribed && <p className="mt-3 flex items-center gap-2 text-xs text-gold" data-id="element-249" data-mp="a9fbkf18v077">
                  <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-250" data-mp="5cfa6hfcalmf" />
                  {t.footer.subscribed}
                </p>}
            </form>
          </div>
        </div>

        <div className="mt-16 rounded-2xl border border-white/10 bg-white/[0.03] p-6" data-id="element-251" data-mp="fal68iegsxjd">
          <h2 className="eyebrow text-gold" data-id="element-252" data-mp="xynbyvfq1fx7">{t.footer.disclaimerTitle}</h2>
          <p className="mt-3 text-xs leading-relaxed text-navy-100/60" data-id="element-253" data-mp="12wf6lx7r3g53">{DISCLAIMER[lang]}</p>
        </div>

        <div className="mt-8 flex flex-col gap-3 border-t border-white/10 pt-6 text-xs text-navy-100/50 sm:flex-row sm:items-center sm:justify-between" data-id="element-254" data-mp="oxffmiwrmp5r">
          <p data-id="element-255" data-mp="ty3grxepkmdp">
            © {new Date().getFullYear()} {COMPANY.legalName}. {t.footer.rights}
          </p>
          <p data-id="element-256" data-mp="f59nn96ik7qk">{t.footer.registration}</p>
        </div>
      </div>
    </footer>;
}